export default "__VITE_ASSET__9JNA5lGF__"